import { useTranslation } from "react-i18next";

const Jumbo: React.FC<{}> = () => {
    const { t } = useTranslation();

    return (
        <section className="jumbo-section">
            <div className="container">
                <div className="notice-block">
                    {t("old_acc_notice")}
                </div>
                <div className="jumbo">
                    <p className="text-wrapper">
                        {t("home_slogan")}
                    </p>
                </div>
                <div className="jumbo-foundation">
                    <p className="text-wrapper">
                        <p className="title">{t("foundation_title")}</p>
                        <p className="subtitle">{t("foundation_subtitle")}</p>
                        <a className="btn-secondary accent" href="http://osnova.viksi666.su/discount">{t("foundation_join")}</a>
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Jumbo;